/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CustomerApiService } from './customer-api.service';

@Injectable({
  providedIn: 'root',
})
export class FilterApiService {
  constructor(private api: CustomerApiService) {}

  getFilter(): Observable<any> {
    return this.api
      .get('/v1/cockpit_filters/get')
      .pipe(catchError(() => of(undefined)));
  }

  delFilter(id: string): Observable<any> {
    return this.api.get('/v1/cockpit_filters/remove', { id });
  }

  setFilter(data: any): Observable<any> {
    return this.api.post('/v1/cockpit_filters/store', data);
  }
}
